import { createContext, useContext, createElement } from "react";

import type { AppFlags } from "../config";

/**
 * Generic Feature Flags
 *
 * Entries consist of the feature flag name as the key and the resolved variant's value as the value.
 */
export type Flags = Partial<AppFlags>;

type FlagContextValue = {
  flags: Flags;
  isLoaded: boolean;
};

const FeatureContext = createContext<FlagContextValue | null>(null);

export function useFlagMap() {
  const ctx = useContext(FeatureContext);
  if (ctx === null) throw new Error("Error: useFlagMap was used outside of FeatureProvider.");
  return ctx.flags;
}

export function useFlagMapWithStatus() {
  const ctx = useContext(FeatureContext);
  if (ctx === null) throw new Error("Error: useFlagMapWithStatus was used outside of FeatureProvider.");
  return ctx;
}

export function FeatureProvider<F extends Flags>(props: {
  value: F;
  isLoaded?: boolean;
  children: React.ReactNode;
}) {
  return createElement(
    FeatureContext.Provider,
    { value: { flags: props.value, isLoaded: props.isLoaded ?? true } },
    props.children
  );
}
